import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.heading',
		defaultMessage: 'Date and time format options',
		description:
			'Heading for the accordion that will show the advanced date and time format options',
	},
	dateAndTimeFormat: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.date-and-time-format',
		defaultMessage: 'Date and time format',
		description:
			'Heading for the field to specify the date and time format to be used during the import',
	},
	locale: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.locale',
		defaultMessage: 'Locale',
		description: 'Heading for the field to specify the locale to be used during the import',
	},
	timezone: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.timezone',
		defaultMessage: 'Timezone',
		description: 'Heading for the field to specify the timezone to be used during the import',
	},
	dateFormatEmpty: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.date-format-empty',
		defaultMessage: 'Date and time format is required',
		description: 'Date and time format validation error message',
	},
	dateFormatHelperMessage: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.date-format-helper-message',
		defaultMessage: 'e.g. dd/MMM/yy h:mm a',
		description: 'Helper text for date time format field',
	},
});
